import { sixEndpoints } from '@/api/endpoints';
import { FileKeyFacilitationService } from '@/services/abstract/FileKeyFacilitationService';
import type { FetcherService } from '@/services/abstract/FetcherService';
import type { AddFileKeysPayload, MissingFileKeyHelpRequest } from '@/types/fileKey/FileKeyFacilitation';
import type { UploadRotatedFileKeysPayload } from '@/types/fileKey/FileKeyRegeneration';

export class FileKeyFacilitationServiceImpl extends FileKeyFacilitationService {
  constructor(private readonly fetcher: FetcherService) {
    super();
  }

  async getMissingFileKeyRequests(): Promise<MissingFileKeyHelpRequest[]> {
    try {
      return await this.fetcher.get<MissingFileKeyHelpRequest[]>(sixEndpoints.getMissingFileKeys());
    } catch (error) {
      if (error instanceof Error && error.message.includes('404')) {
        return [];
      }
      throw error;
    }
  }

  async uploadFileKeysBundle(payload: UploadRotatedFileKeysPayload): Promise<void> {
    await this.fetcher.post(sixEndpoints.uploadFileKeysBundle, payload, {
      suppressPollingErrors: true,
    });
  }

  async submitFileKeys(payload: AddFileKeysPayload): Promise<void> {
    await this.fetcher.post(sixEndpoints.addFileKeys, payload, {
      suppressPollingErrors: true,
    });
  }
}
